import React, { useEffect, useState, useCallback } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Checkbox, Box, Typography } from '@mui/material';
import { useAppSelector } from '../../hooks';
import { BasicDataTypes } from '../../types/types';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  openDrawer: boolean;
}

const CategoryFilter: React.FC<Props> = ({ openDrawer }) => {
  const { data } = useAppSelector((state) => state.frontViewData);
  const [categories, setCategories] = useState<BasicDataTypes[]>([]);
  const [checked, setChecked] = useState<number[]>([]);
  const location = useLocation();
  const navigate = useNavigate();

  const handleToggle = useCallback((value: number) => () => {
    setChecked((prevChecked) => {
      const currentIndex = prevChecked.indexOf(value);
      let updatedChecked;
      if (currentIndex === -1) {
        updatedChecked = [...prevChecked, value];
      } else {
        updatedChecked = prevChecked.filter((item) => item !== value);
      }
      updateSearchParams(updatedChecked);
      return updatedChecked;
    });
  }, [location.search]);

  const updateSearchParams = useCallback((checkedValues: number[]) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('category');
    searchParams.delete('page');
    checkedValues.forEach((value) => {
      searchParams.append('category', String(value));
    });
    navigate(`?${searchParams.toString()}&page=1`);
  }, [navigate, location.search]);

  useEffect(() => {
    if (data && data.data) {
      const fetchedData = data.data;
      const categoryData = fetchedData?.categories || [];
      setCategories(categoryData);
    }
  }, [data]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const checkedValues = searchParams.getAll('category').map(Number);
    setChecked(checkedValues);
  }, [location.search, openDrawer]);

  return (
    <Box>
      <Typography sx={{ mb: 2 }}>Job Categories</Typography>
      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        {categories.map((category) => {
          const labelId = `checkbox-list-label-${category.id}`;
          const isChecked = checked.includes(category.id);

          return (
            <ListItem key={category.id} disablePadding>
              <Box
                onClick={handleToggle(category.id)}
                sx={{ display: 'flex', pl: 0, cursor: 'pointer' }}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={isChecked}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={category.name} />
              </Box>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default CategoryFilter;
